module.exports = __webpack_public_path__ + "static/media/splash-unesul.20f1a105.png";